module.exports = __webpack_public_path__ + "fonts/s2l.3eea5d3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/s2l.ttf?1k5k71
// module id = 1105
// module chunks = 0